import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { ErrorsService } from './errors.service';

@Component({
  selector:    'ai-error',
  templateUrl: './errors.component.html',
  styleUrls:   ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {
  routeParams;
  data;

  constructor (
    private activatedRoute: ActivatedRoute,
    private errorsService: ErrorsService,
    private router: Router
  ) {}

  ngOnInit () {
    this.routeParams = this.activatedRoute.snapshot.queryParams;
    this.activatedRoute.data.subscribe((data: Data) => console.log(data));
    this.data = {
      ...this.activatedRoute.snapshot.data,
      ...this.activatedRoute.snapshot.params
    };

    /* TODO: find better way to log 404 error */
    if (this.activatedRoute.snapshot.data.error === '404') {
      this.errorsService.log(new Error(`Error 404. Page ${this.router.url} not found`));
    }
  }
}
